import { useUserInfor } from "../../../../../../../Context/User";
import { AtualizarConfigGeralController } from "../../../../../../../Controllers/Geral/GestaoDeCadastros/ConfigGeral/ConfigGeralController";
import OrSpinner from "../../../../../../Utils/OrSpinner";

export default function AutomacaoConfig() {
    const { Config, updateConfig } = useUserInfor();

    function update() {
        AtualizarConfigGeralController({
            ...Config,
        }).then(() => {
            updateConfig();
        });
    }
    return (
        <OrSpinner loading={false} loadingColor="primary">
            <h4>Disparar régua no final de semana</h4>
            <div className="d-flex flex-column">
                <label className="col-12 col-form-label px-0">
                    Permitir o disparo da régua nos finais de semana
                </label>
                <div className="col-12">
                    <span className="switch switch-outline switch-icon switch-success">
                        <label>
                            <input
                                type="checkbox"
                                checked={
                                    Config.ConfigCobrancaDTO
                                        .FL_COB_DISPARAR_EMAIL_COBRANCA_FIM_DE_SEMANA
                                }
                                onChange={() => {
                                    Config.ConfigCobrancaDTO.FL_COB_DISPARAR_EMAIL_COBRANCA_FIM_DE_SEMANA =
                                        !Config.ConfigCobrancaDTO
                                            .FL_COB_DISPARAR_EMAIL_COBRANCA_FIM_DE_SEMANA;
                                    update();
                                }}
                                name="select"
                            />
                            <span></span>
                        </label>
                    </span>
                </div>
            </div>
        </OrSpinner>
    );
}
